import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, tap } from 'rxjs';

import { switchMapToVoid } from '@ideals/utils/void';

import { DiagnosticStatus, ErrorDetails } from '../../models';

import { Troubleshooting } from './troubleshooting';

export class CheckInternetConnectionService extends Troubleshooting {
  readonly #translateService = inject(TranslateService);

  #status: DiagnosticStatus = 'Default';

  override getErrorDetails(): ErrorDetails {
    return {
      title: this.#translateService.instant('help_modal.TEXT.No_internet') as string,
      description: this.#translateService.instant('help_modal.TEXT.Check_your_device') as string,
      dataIdeals: 'copy-internet-issues',
    };
  }

  override getErrorReports(): { [key: string]: string; } {
    return { internet: navigator.onLine ? 'online' : 'offline' };
  }

  override getStatus(): DiagnosticStatus {
    return this.#status;
  }

  override run(): Observable<void> {
    this.#status = 'InProgress';

    return of(navigator.onLine).pipe(
      tap((online) => {
        this.#status = online ? 'Completed' : 'Error';
      }),
      switchMapToVoid,
    );
  }
}
